/**
 * Deep T, intermission 4: a zigzag sprint that starts with only seconds on the clock. Two clocks
 * on the way keep you going if you do not stray (docs/spec/03 §3).
 */

import type { CaveDef } from '../types';

export const deepT: CaveDef = {
  id: 'T',
  name: 'LAST SECONDS',
  hint: 'Seconds, not minutes. Run from clock to clock.',
  intermission: true,
  colors: [11, 14, 7],
  diamondValue: 30,
  extraValue: 40,
  fill: { base: '.', items: [['d', 10], [' ', 10]] },
  levels: [
    { seed: 7001, diamonds: 6, time: 12 },
    { seed: 7002, diamonds: 7, time: 10 },
    { seed: 7003, diamonds: 8, time: 8 },
    { seed: 7004, diamonds: 9, time: 7 },
    { seed: 7005, diamonds: 10, time: 6 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWW',
    'WP.???d???.???d???.W',
    'Wwwwwwwwwwwwwwwwww.W',
    'W.?d???t??.???d???.W',
    'W.wwwwwwwwwwwwwwwwwW',
    'W.???d????.???d???.W',
    'Wwwwwwwwwwwwwwwwww.W',
    'W.?d????t?.???d???.W',
    'W.wwwwwwwwwwwwwwwwwW',
    'W.???d????.???d???.W',
    'WwwwwwwwwwwwwwwwwwXW',
    'WWWWWWWWWWWWWWWWWWWW',
  ],
};
